<script lang="ts">
  import type {Image} from "../../../types/CinemaProductsDto.types.ts";
  import type {Snippet} from "svelte";

  type ProductImageProps = {
    image: Image;
    lazyLoad: boolean;
    children: Snippet;
  };

  let {image, lazyLoad, children}: ProductImageProps = $props();

  let imageLoaded = $state(false);
  let loadingError = $state(false);

  const SPA_AMBIENT_PRESET = "$spa_ambiente$";
  const TILE_PORTRAIT_PRESET = "$tile_portrait$";

  function getImageUrl(): string {
    const isCutout = image.clippingType === "FREIGESTELLT" && image.grayBackground;

    const queryParam = isCutout
      ? TILE_PORTRAIT_PRESET
      : SPA_AMBIENT_PRESET;

    return `${image.url}?${queryParam}`;
  }

  const imgSrc = $derived(getImageUrl());
</script>

<div class="cinema-product-image"
     class:clean_cutout_overlay={image.grayBackground}
     style:aspect-ratio="3 / 4">
  <picture>
    {#if !loadingError}
      <source srcset="{imgSrc}&fmt=auto"/>
    {/if}
    <img
      loading={lazyLoad ? "lazy" : "eager"}
      data-src={imgSrc}
      src={lazyLoad ? "" : imgSrc}
      alt={image.alt}
      class={
        image.clippingType === "FREIGESTELLT" && image.grayBackground
          ? "cutout_padding"
          : image.clippingType === "AMBIENTE"
            ? "ambient"
            : undefined
      }
      class:loaded={imageLoaded}
      onload={() => (imageLoaded = true)}
      onerror={() => {
        loadingError = true;
      }}
    />
  </picture>

  {@render children()}

  {#if !imageLoaded}
    <div class="cinema-product-image__spinner">
      <oc-spinner-v1 size={/*                      */ "200"} variant="default"></oc-spinner-v1>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .cinema-product-image {
    position: relative;
    overflow: hidden;
    margin-bottom: tokens.$oc-semantic-spacing-75;
    border-radius: tokens.$oc-semantic-border-radius-150;

    img {
      position: absolute;
      max-width: 100%;
      max-height: 100%;
    }

    img.ambient {
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    img.cutout_padding {
      height: auto;
      padding: 10%;
    }

    &.clean_cutout_overlay::after {
      content: "";
      position: absolute;
      inset: 0;
      z-index: 1;
      background-color: rgba(33, 33, 33, 0.06);
      pointer-events: none;
    }

    &__spinner {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
</style>
